import React from "react";
import { ShoppingBag, PackageSearch } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_2c76cf32-2b84-4c50-9f36-10bc5c316a14/artifacts/s740rexd_New%20Logo.png";

export default function Header() {
  const { count, setIsOpen } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  const goToSection = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/80 border-b border-[#E5DFD3]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="header-logo-link"
        >
          <img
            src={LOGO_URL}
            alt="Thai Tasty Treats"
            className="h-12 w-12 object-contain"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-display text-[#2C4C3B] text-xl tracking-tight">
              Thai Tasty Treats
            </div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#4A5D53]">
              Craft &middot; Cold &middot; Brewed
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm text-[#1F2924]">
          <button
            data-testid="nav-shop"
            onClick={() => goToSection("shop")}
            className="hover:text-[#D96C2B] transition-colors"
          >
            Shop
          </button>
          <button
            data-testid="nav-story"
            onClick={() => goToSection("story")}
            className="hover:text-[#D96C2B] transition-colors"
          >
            Our Story
          </button>
          <button
            data-testid="nav-contact"
            onClick={() => goToSection("contact")}
            className="hover:text-[#D96C2B] transition-colors"
          >
            Contact
          </button>
          <Link
            to="/orders/lookup"
            data-testid="nav-order-lookup"
            className="inline-flex items-center gap-1.5 hover:text-[#D96C2B] transition-colors"
          >
            <PackageSearch className="h-3.5 w-3.5" />
            Track Order
          </Link>
        </nav>

        <button
          data-testid="open-cart-btn"
          onClick={() => setIsOpen(true)}
          className="relative inline-flex items-center gap-2 px-5 py-2.5 bg-[#2C4C3B] text-[#FDFBF7] text-sm uppercase tracking-wider hover:bg-[#1C3327] transition-colors"
        >
          <ShoppingBag className="h-4 w-4" />
          <span>Cart</span>
          {count > 0 && (
            <span
              data-testid="cart-count-badge"
              className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-[#D96C2B] text-white text-[11px] font-semibold flex items-center justify-center"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
